<div
  class="is-flex is-justify-content-center is-align-content-center"
  style="width: 100%; height: 500px"
>
  <ng-lottie [options]="options" width="280px"></ng-lottie>
</div>
